import Swiper from 'swiper'
import { Navigation, Thumbs } from 'swiper/modules'

export const gallery = () => {
	const slider = document.querySelector('[data-swiper-gallery]')
	const thumbnails = document.querySelector('[data-swiper-thumbnails]')

	if (!slider) return

	const thumbs = new Swiper(thumbnails, {
		spaceBetween: 14,
		slidesPerView: 'auto',
		watchSlidesProgress: true,
		breakpoints: {
			650: {
				spaceBetween: 26
			}
		}
	})
	
	const swiper = new Swiper(slider, {
		modules: [Thumbs, Navigation],
		speed: 750,
		spaceBetween: 24,
		slidesPerView: 1,
		thumbs: {
			swiper: thumbs
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		}
	})

}

export default () => {}
